import { validateEmail } from '@/utils/validate'
import Common from '@/utils/common'
export default {
  name: 'login',
  data () {
    const validateUsername = (rule, value, callback) => {
      if (!validateEmail(value)) {
        callback(new Error('Please enter the valid email address'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('The password can not be less than 6 digits'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      passwordType: 'password',
      loading: false,
      showDialog: false,
      isError: undefined
    }
  },
  methods: {
    showPwd () {
      this.passwordType = this.passwordType === 'password' ? '' : 'password'
    },
    handleLogin () {
      this.isError = undefined
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('Login', this.loginForm).then(() => {
            // this.loading = false
            this.$router.push({ path: '/' })
          }).catch((err) => {
            console.log(err.response)
            if (err.response.status === 401) {
              this.isError = 'Unauthorized!'
            } else if (err.response.status === 402) {
              this.isError = 'Account is not activated.'
            } else if (err.response.status === 403) {
              this.isError = 'Account is banned.'
            } else if (err.response.status === 500) {
              this.isError = 'Something went wrong!'
            } else {
              this.isError = 'Incorrect email or password.'
            }
            this.loading = false
          })
        } else {
          this.isError = undefined
          return false
        }
      })
    },
    onHelpClick () {
      this.$alert(
        '<ul style="list-style-type: decimal;padding-left: 15px;"><li>Check your email to see if your password has been reset.</li>' +
        '<li>Check your email’s junk/spam folder to see if email ended up there? Please mark as “Not Junk/Spam” for future convenience.</li>' +
        '<li>If you are still having trouble, please contact your sales representative.</li></ul>',
        'Help', {
          dangerouslyUseHTMLString: true
        }
      )
    },
    afterQRScan () {
      // const hash = window.location.hash.slice(1)
      // const hashObj = getQueryObject(hash)
      // const originUrl = window.location.origin
      // history.replaceState({}, '', originUrl)
      // const codeMap = {
      //   wechat: 'code',
      //   tencent: 'code'
      // }
      // const codeName = hashObj[codeMap[this.auth_type]]
      // if (!codeName) {
      //   alert('第三方登录失败')
      // } else {
      //   this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
      //     this.$router.push({ path: '/' })
      //   })
      // }
    }
  },
  created () {
    // window.addEventListener('hashchange', this.afterQRScan)
  },
  destroyed () {
    // window.removeEventListener('hashchange', this.afterQRScan)
  }
}



// WEBPACK FOOTER //
// ./src/views/login/index.js